import {useEffect, useState} from "react";
import {MOBILE_MAX_WIDTH} from "@/styles/sizes";

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

// Returns whether we are below the mobile breakpoint, matching the CSS exactly.
// Seed it with the server's User-Agent guess so the markup a phone receives is
// already the mobile one; after hydration the media query takes over, which also
// keeps it correct when the window is resized across the breakpoint.
export default function useIsMobile(serverDefault = false) {
    const [isMobile, setIsMobile] = useState(serverDefault);

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) {
            return;
        }

        const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
        const sync = () => setIsMobile(mediaQuery.matches);

        sync();
        mediaQuery.addEventListener("change", sync);

        return () => mediaQuery.removeEventListener("change", sync);
    }, []);

    return isMobile;
}
